//api url
export default {
  apiBaseUrl: 'https://safe-plains-14013.herokuapp.com/api',
};
